module.exports = __webpack_public_path__ + "6f20e269bde8cbd2479561cfd5488d52.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/flask-orange.png
// module id = 2641
// module chunks = 0